import React from "react";
import _filter from "lodash/filter";
import { commaJoin } from "shared-utils";
import { useTranslation } from "i18n";
import { useGetBasicInfo } from "pages/Profile/hooks/useGetBasicInfo";

const DetailsPrint = () => {
  const { t } = useTranslation();
  const { basicInfo, basicInfoConfiguration } = useGetBasicInfo();

  const col1 = _filter(
    [
      {
        label: t("common:label.location"),
        value: commaJoin(basicInfo.locations),
      },
      {
        label: t("common:label.workPermits"),
        value:
          basicInfoConfiguration.isVisibleVisasAndPermits &&
          commaJoin(basicInfo.visasAndPermits),
      },
      {
        label: t("common:label.gender"),
        value:
          basicInfoConfiguration.isVisibleGender &&
          commaJoin(basicInfo.genders),
      },
      {
        label: t("common:label.disability"),
        value:
          basicInfoConfiguration.isVisibleDisability &&
          commaJoin(basicInfo.disabilities),
      },
      {
        label: t("common:label.actualAge"),
        value: basicInfoConfiguration.isVisibleActualAge && basicInfo.actualAge,
      },
      { label: t("common:label.playingAge"), value: basicInfo.playingAge },
      { label: t("common:label.height"), value: basicInfo.height },
      {
        label: t("common:label.nationalities"),
        value: commaJoin(basicInfo.nationalities),
      },
      {
        label: t("common:label.ethnicityOrHeritage"),
        value:
          basicInfoConfiguration.isVisibleHeritageAndEthnicity &&
          commaJoin(basicInfo.ethnicity),
      },
      {
        label: t("common:label.membership"),
        value: commaJoin(basicInfo.memberships),
      },
    ],
    "value"
  );
  const col2 = _filter(
    [
      {
        label: t("common:label.appearance"),
        value: commaJoin(basicInfo.appearances),
      },
      { label: t("common:label.complexionShades"), value: basicInfo.makeUp },
      { label: t("common:label.twin"), value: basicInfo.hasTwin },
      { label: t("common:label.hairColour"), value: basicInfo.hairColor },
      { label: t("common:label.hairLength"), value: basicInfo.hairLength },
      { label: t("common:label.facialHair"), value: basicInfo.facialHair },
      { label: t("common:label.eyeColour"), value: basicInfo.eyeColor },
      {
        label: t("common:label.voiceStyles"),
        value: commaJoin(basicInfo.voiceStyle),
      },
      { label: t("common:label.vocalRange"), value: basicInfo.vocalRange },
      { label: t("common:label.vocalAge"), value: basicInfo.vocalAge },
      { label: t("common:label.hat"), value: basicInfo.hatSize },
      { label: t("common:label.chest"), value: basicInfo.chestSize },
      { label: t("common:label.waist"), value: basicInfo.waistSize },
      { label: t("common:label.hips"), value: basicInfo.hipsSize },
      { label: t("common:label.insideArm"), value: basicInfo.insideArmSize },
      { label: t("common:label.insideLeg"), value: basicInfo.insideLegSize },
      { label: t("common:label.weight"), value: basicInfo.weight },
      { label: t("common:label.collar"), value: basicInfo.collarSize },
      { label: t("common:label.shoeSize"), value: basicInfo.shoeSize },
      { label: t("common:label.ukDressSize"), value: basicInfo.dressSize },
    ],
    "value"
  );

  if (!col1.length && !col2.length) return null;

  return (
    <div className="grid grid-cols-2 gap-x-8 gap-y-1 border-gray-100">
      {!!col1.length && (
        <div className="space-y-1">
          {col1.map((item) => (
            <p key={item.label}>
              <strong>{item.label}:</strong> {item.value}
            </p>
          ))}
        </div>
      )}

      {!!col2.length && (
        <div className="space-y-1">
          {col2.map((item) => (
            <p key={item.label}>
              <strong>{item.label}:</strong> {item.value}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default DetailsPrint;
